import React from 'react';
import { useTranslation } from 'react-i18next';
import { Section, SectionSubTitle, Swiper, SwiperSlide, Typography } from 'common/components';
import { KAZAKHSTAN } from 'common/constants/region-codes';
import { createElementKey } from 'utils/create-element-key';
import { BATHROOM_CDN_PATH } from '../../old-bathroom-constants';
import { RESULT_LIST } from './result-section-constants';
import {
  DownloadResultImage,
  dowloadResultText,
  Result,
  ResultContent,
  ResultImage,
  resultSection,
  resultSubtitleStyle,
  resultTextStyle,
  swiperStyle,
  swiperSlideStyle,
} from './result-section-styles';

/**
 * Вью секции "Результат"
 */
export const ResultSection = ({ regionId }: { regionId: string }) => {
  const { t } = useTranslation();

  return (
    <Section className={resultSection}>
      <SectionSubTitle adaptiveMargin margin="s">
        {t('result-section.title-main')}
      </SectionSubTitle>

      <Typography className={resultTextStyle} size="body_long" variant="m">
        {t('result-section.description')}
      </Typography>

      {regionId !== KAZAKHSTAN && (
        <Result
          elementBlock="landingVannuyuKomnatu"
          elementName={t('result-section.example.title')}
          elementText={t('result-section.title-main')}
          href="https://storage.yandexcloud.net/lemanapro-ru-landings-docs/bathroom/bathroom-project-example.pdf"
          download
          rel="noreferrer"
          target="_blank"
          title={t('result-section.example.link-title')}>
          <ResultContent>
            <Typography adaptive={false} className={dowloadResultText} variant="m" size="subtitle">
              {t('result-section.example.title')}
            </Typography>
            <Typography variant="caption">PDF, 11&nbsp;МБ</Typography>
          </ResultContent>
          <DownloadResultImage
            alt={t('result-section.example.link-title') || ''}
            src={`${BATHROOM_CDN_PATH}/result/example-icon.png/example-icon.png`}
          />
        </Result>
      )}

      <Typography className={resultSubtitleStyle} variant="h3" as="h3">
        {t('result-section.title-second')}
      </Typography>
      <Swiper slidesPerView="auto" watchOverflow className={swiperStyle}>
        {RESULT_LIST.map((result, index) => (
          <SwiperSlide key={createElementKey('result', index)} className={swiperSlideStyle}>
            <ResultImage src={result.src} alt={result.alt} title={result.alt} loading="lazy" />
            <Typography className={result.className} size="body_long" variant="m">
              {t(result.text)}
            </Typography>
          </SwiperSlide>
        ))}
      </Swiper>
    </Section>
  );
};
